import { render, staticRenderFns } from "./remember.vue?vue&type=template&id=47544226&scoped=true&"
import script from "./remember.vue?vue&type=script&lang=js&"
export * from "./remember.vue?vue&type=script&lang=js&"
import style0 from "./remember.vue?vue&type=style&index=0&id=47544226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47544226",
  null
  
)

export default component.exports